<template>
  <div class="select-home-items">
    <h1>Select which {{ this.topic }} posts show up on the home page.</h1>
    <select v-model="firstSelectedPostId">
      <option disabled value="">Please select one</option>
      <option v-for="post in posts" :value="post.id" :key="post.id">{{
        post.title
      }}</option>
    </select>
    <br />
    <select v-model="secondSelectedPostId">
      <option disabled value="">Please select one</option>
      <option v-for="post in posts" :value="post.id" :key="post.id">{{
        post.title
      }}</option>
    </select>
    <br />
    <select v-model="thirdSelectedPostId">
      <option disabled value="">Please select one</option>
      <option v-for="post in posts" :value="post.id" :key="post.id">{{
        post.title
      }}</option>
    </select>
    <br />
    <select v-model="fourthSelectedPostId">
      <option disabled value="">Please select one</option>
      <option v-for="post in posts" :value="post.id" :key="post.id">{{
        post.title
      }}</option>
    </select>
    <br />
    <button @click="updateDisplayOnHomeAttribute">Save</button>
  </div>
</template>

<script>
import db from '@/firebase/init';

export default {
  name: 'SelectHomeItems',
  data() {
    return {
      posts: [],
      topic: this.$route.params.topicName,
      firstSelectedPostId: '',
      secondSelectedPostId: '',
      thirdSelectedPostId: '',
      fourthSelectedPostId: '',
    };
  },

  methods: {
    getPosts() {
      db.collection('posts')
        .where('topic', '==', this.topic)
        .get()
        .then(snapshot => {
          snapshot.forEach(doc => {
            let post = doc.data();
            post.id = doc.id;
            this.posts.push(post);
          });
        });
    },

    updateDisplayOnHomeAttribute() {
      this.posts.forEach(post => {
        if (
          post.id === this.firstSelectedPostId ||
          post.id === this.secondSelectedPostId ||
          post.id === this.thirdSelectedPostId ||
          post.id === this.fourthSelectedPostId
        ) {
          let displayOnHomeBool = true;
          db.collection('posts')
            .doc(post.id)
            .update({
              displayOnHome: displayOnHomeBool,
            })
            .then(() => {
              console.log('Updated displayOnHomeBool attribute!');
              this.$router.push({ name: 'Home' });
            })
            .catch(error => {
              console.error('Error writing document: ', error);
            });
        } else {
          let displayOnHomeBool = false;
          db.collection('posts')
            .doc(post.id)
            .update({
              displayOnHome: displayOnHomeBool,
            })
            .then(() => {
              console.log('Updated displayOnHomeBool attribute!');
            })
            .catch(error => {
              console.error('Error writing document: ', error);
            });
        }
      });
    },
  },
  created() {
    this.getPosts();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/SelectHomeItems.vue